export default __webpack_public_path__ + "static/media/WeeklyInspirationLock.97a1c5ba.png";